<div class=" " *ngIf="showRequest">
  <h2 class="sectionTitle">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.FIBBERGLASS_CONTRACT' | translate }}</h2>
  <!-- <div>
    <app-request-details [baseRequest]="baseRequestDTO"></app-request-details>
  </div> -->
  <app-admin-decision [IsReadOnly]="readonly"></app-admin-decision>

  <!-- <div>
    <app-fibberglass-request></app-fibberglass-request>
  </div> -->
  <form [formGroup]="ConfirmContractForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CONTRACT_CONFIRMATION' | translate }}</label>
      <span class="red"> *</span>
      <div class="custom-checkbox">
        <input type="checkbox" id="ContractConfirmation" name="ContractConfirmation"
          formControlName="ContractConfirmation" />
        <label
          for="ContractConfirmation">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CONTRACT_CONFIRMATION_ACCEPTANCE' | translate }}</label>
      </div>
      <div *ngIf="submitted && Validate.ContractConfirmation?.errors" class="red">
        <div *ngIf="Validate.ContractConfirmation?.errors?.required">
          {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      </div>
    </div>
    <div class="form-group">
      <button [disabled]="loading" class="SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate }}</button>
    </div>
  </form>
</div>
<!-- Confirmation -->
<div *ngIf="!showRequest" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CONFIRM_CONTRACT_SUCCESS_MESSAGE' | translate }}</p>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>
